var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons/faSpinner';
import { faCircle } from '@fortawesome/pro-duotone-svg-icons/faCircle';
import { Container } from './styles';
var renderDoneIcon = function (_a) {
    var color = _a.color, size = _a.size, doneIcon = _a.doneIcon;
    return doneIcon !== null ? (_jsx(FontAwesomeIcon, { color: color, size: size, icon: doneIcon })) : null;
};
var SubtleLoader = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'rgba(0, 0, 0, 0.25)' : _b, _c = _a.height, height = _c === void 0 ? 40 : _c, _d = _a.style, style = _d === void 0 ? {} : _d, _e = _a.size, size = _e === void 0 ? '1x' : _e, _f = _a.loading, loading = _f === void 0 ? false : _f, _g = _a.doneIcon, doneIcon = _g === void 0 ? faCircle : _g;
    return (_jsxs(Container, __assign({ height: height, style: style }, { children: [loading && (_jsx(FontAwesomeIcon, { color: color || '#858585', size: size, icon: faSpinner, spin: true })), !loading && renderDoneIcon({ color: color, size: size, doneIcon: doneIcon })] })));
};
export default SubtleLoader;
